<template>
<div class="chapter">
<div class="inner_page">
<p class="chaptitlea"><a id="page_vi"></a><strong>List of Illustrations</strong></p>
<p class="toc-fig"><a href="#/08_chapter_01#fig1"><span class="chap">1</span> Strong Vincent as a young man, c. 1860</a></p>
<p class="toc-fig"><a href="#/09_chapter_02#fig2"><span class="chap">2</span> Colonel John W. McLane, c. 1861</a></p>
<p class="toc-fig"><a href="#/09_chapter_02#fig3"><span class="chap">3</span> Private Oliver W. Norton, c. 1861</a></p>
<p class="toc-fig"><a href="#/09_chapter_02#fig4"><span class="chap">4</span> Lieutenant Amos M. Judson, 1862</a></p>
<p class="toc-fig"><span href="#/10_chapter_03#fig5" title="Link target outside of Sample"><span class="chap">5</span> Lieutenant Strong Vincent, c. 1861</span></p>
<p class="toc-fig"><span href="#/12_chapter_05#fig6" title="Link target outside of Sample"><span class="chap">6</span> Color Sergeant Alex Rogers with the 83rd Pennsylvania’s flag, 1862</span></p>
<p class="toc-fig"><span href="#/13_chapter_06#fig7" title="Link target outside of Sample"><span class="chap">7</span> Elizabeth Carter Vincent, c. 1850s</span></p>
<p class="toc-fig"><span href="#/13_chapter_06#fig8" title="Link target outside of Sample"><span class="chap">8</span> Colonel Strong Vincent, 1863</span></p>
<p class="toc-fig"><span href="#/18_chapter_11#fig9" title="Link target outside of Sample"><span class="chap">9</span> Marble marker to Vincent on Little Round Top</span></p>
<p class="toc-fig"><span href="#/18_chapter_11#fig10" title="Link target outside of Sample"><span class="chap">10</span> Grave of Brigadier General Vincent in Erie Cemetery</span></p>
<p class="toc-fig"><span href="#/18_chapter_11#fig11" title="Link target outside of Sample"><span class="chap">11</span> Inscription on the boulder where Vincent was mortally wounded</span></p>
<p class="toc-fig"><span href="#/18_chapter_11#fig12" title="Link target outside of Sample"><span class="chap">12</span> The monument to the 83rd Pennsylvania at Gettysburg</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_illustrations.vue?271f8eb4